import React from 'react';
import * as Funciones from '../../funciones/FuncionesFixture.js';
import styles from './PreviewFixtureAutomatico.module.css';

/**
 * Preview del fixture generado automáticamente (todas las fechas), con acciones de confirmar/volver.
 */
const PreviewFixtureAutomatico = (props) => {
  const fixtureAutomatico = props.fixtureAutomatico || [];
  const mostrarZona = props.mostrarZona;
  const isConfirmando = props.isConfirmando;
  const onConfirmar = props.onConfirmar;
  const onVolver = props.onVolver;

  if (!fixtureAutomatico || fixtureAutomatico.length === 0) {
    return null;
  }

  const gruposPorFecha = Funciones.OrdenarPreviewFixture(fixtureAutomatico).reduce(
    (acumulado, partido) => {
      const fecha = Number(partido.nroFecha || 0);
      if (!acumulado[fecha]) {
        acumulado[fecha] = [];
      }
      acumulado[fecha].push(partido);
      return acumulado;
    },
    {}
  );

  const fechasOrdenadas = Object.keys(gruposPorFecha)
    .map((valor) => Number(valor))
    .sort((a, b) => a - b);

  return (
    <div className={styles.grupo}>
      <h4>Preview del fixture completo</h4>
      <div className={styles.previewFixture}>
        {fechasOrdenadas.map((fecha) => (
          <div key={`preview-fecha-${fecha}`} className={styles.previewFecha}>
            <div className={styles.previewTituloFecha}>Fecha {fecha}</div>
            <table className={styles.previewTabla}>
              <thead>
                <tr>
                  <th className={styles.previewColOrden}>#</th>
                  {mostrarZona && <th className={styles.previewColZona}>Zona</th>}
                  <th className={styles.previewColEquipo}>Local</th>
                  <th className={styles.previewColEquipo}>Visitante</th>
                </tr>
              </thead>
              <tbody>
                {gruposPorFecha[fecha].map((partido, index) => (
                  <tr key={`${fecha}-${index}`}>
                    <td className={styles.previewColOrden}>
                      {partido.orden || partido.ordenPartido || ''}
                    </td>
                    {mostrarZona && (
                      <td className={styles.previewColZona}>
                        {Funciones.NormalizarZona(partido.zona) || ''}
                      </td>
                    )}
                    <td className={styles.previewColEquipo}>
                      {partido.nombreEquipoLocal ||
                        partido.nombreLocal ||
                        partido.equipoLocal?.nombre ||
                        `Equipo ${partido.idEquipoLocal || ''}`}
                    </td>
                    <td className={styles.previewColEquipo}>
                      {partido.equipoLibre
                        ? '(libre)'
                        : partido.nombreEquipoVisitante ||
                          partido.nombreVisitante ||
                          partido.equipoVisitante?.nombre ||
                          `Equipo ${partido.idEquipoVisitante || ''}`}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
      <div className={styles.accionesModo}>
        <button className={styles.btnModoFixture} onClick={onConfirmar} disabled={isConfirmando}>
          Confirmar fixture
        </button>
        <button
          className={styles.btnModoFixtureSecundario}
          onClick={onVolver}
          disabled={isConfirmando}
        >
          Volver
        </button>
      </div>
    </div>
  );
};

export default PreviewFixtureAutomatico;
